// client/src/pages/Vods.jsx
import React, { useEffect, useState } from "react";
import StreamPlayer from "../components/StreamPlayer.jsx";

const API_BASE = process.env.REACT_APP_API_URL || "";
const api = (p) => (API_BASE ? `${API_BASE}${p}` : `/api${p}`);

export default function Vods() {
  const [vods, setVods] = useState([]);
  const [selected, setSelected] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch(api("/vods"));
        if (!r.ok) throw new Error(String(r.status));
        const data = await r.json();
        const items = Array.isArray(data?.items) ? data.items : Array.isArray(data) ? data : [];
        setVods(items);
        if (items[0]) setSelected(items[0]);
      } catch (e) {
        setErr(e.message || "failed");
      }
    })();
  }, []);

  return (
    <div className="space-y-4">
      <div className="rounded-2xl bg-[#101827] border border-white/10 p-4">
        <h1 className="text-3xl font-extrabold text-slate-100 mb-1">VODs</h1>
        <p className="text-slate-400 text-sm">{vods.length} videos</p>
        {err && <p className="text-rose-400 text-sm mt-2">GET /api/vods {err}</p>}

        <div className="mt-4 rounded-xl overflow-hidden border border-white/10 bg-black/60">
          <div className="aspect-video">
            <StreamPlayer playbackId={selected?.playbackId || ""} poster={selected?.poster || ""} />
          </div>
        </div>

        {selected && (
          <div className="mt-2 text-slate-300 text-sm">
            <div className="font-semibold">{selected.title || "Untitled VOD"}</div>
            {selected.createdAt && (
              <div className="text-slate-400">{new Date(selected.createdAt).toLocaleString()}</div>
            )}
          </div>
        )}
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {vods.map((v) => (
          <button
            key={v.id || v.playbackId}
            onClick={() => setSelected(v)}
            className={`text-left rounded-xl overflow-hidden border transition ${
              selected?.playbackId === v.playbackId ? "border-sky-400" : "border-white/10"
            } bg-[#0e1726]`}
          >
            <div className="aspect-video bg-black/60">
              {v.poster ? (
                <img src={v.poster} alt="" className="w-full h-full object-cover" />
              ) : null}
            </div>
            <div className="p-2">
              <div className="text-slate-100 text-sm truncate">{v.title || "Untitled VOD"}</div>
              <div className="text-slate-400 text-xs">
                {v.createdAt ? new Date(v.createdAt).toLocaleDateString() : ""}
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
